import formValidation from '../../vendors/FormValidation/core/Core';
import Message from '../../vendors/FormValidation/plugins/Message';
import Trigger from '../../vendors/FormValidation/plugins/Trigger';
import SubmitButton from '../../vendors/FormValidation/plugins/SubmitButton';

import SelectorEngine from './dom/selector-engine';
import ValidationUtils from './validation';

export const VALID_POSTCODE_CHECK = /^(gir 0a{2})|((([a-z]\d{1,2})|(([a-z][a-hj-y]\d{1,2})|(([a-z]\d[a-z])|([a-z][a-hj-y]\d[a-z]?))))\s?\d[a-z]{2})$/i;

const attachValidation = (form, fields) => formValidation(
	form,
	{
		fields,
		plugins: {
			trigger: new Trigger(),
			submitButton: new SubmitButton(),
			message: new Message({
				clazz: 'lta-text-input__label-instruction',
				container: function(field, element) {
					let fieldType = element.getAttribute('type');
					if (!fieldType) {
						fieldType = `${element.nodeName.toLowerCase()}`;
					}
					const inputWrapper = element.closest(ValidationUtils.getFieldWrapper(fieldType));
					return SelectorEngine.findOne('.lta-text-input--error', inputWrapper);
				}
			}),
		}
	}
)
	.on('core.field.invalid', (name) => {
		const invalidField = form.querySelector('[name="'+name+'"]');
		let invalidFieldType = invalidField.getAttribute('type');
		if (!invalidFieldType) {
			invalidFieldType = `${invalidField.nodeName.toLowerCase()}`;
		}
		const fieldWrapper = invalidField.closest(ValidationUtils.getFieldWrapper(invalidFieldType));
		fieldWrapper.classList.add(...ValidationUtils.getErrorClasses(invalidFieldType));
	})
	.on('core.field.valid', (name) => {
		const invalidField = form.querySelector('[name="'+name+'"]');
		let invalidFieldType = invalidField.getAttribute('type');
		if (!invalidFieldType) {
			invalidFieldType = `${invalidField.nodeName.toLowerCase()}`;
		}
		const fieldWrapper = invalidField.closest(ValidationUtils.getFieldWrapper(invalidFieldType));
		fieldWrapper.classList.remove(...ValidationUtils.getErrorClasses(invalidFieldType));
	});

export default attachValidation;
